import Currency from 'components/Currency/Currency';
import DataTable from 'components/DataTable';
import RenderInfo from 'components/RenderInfo';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo } from 'react';
import { CentsToDollar } from 'utils';

const SalesPersonSummary = ({ summary, loading }) => {
  const salesPersonSummaryColumns = useMemo(() => [
    {
      name: 'Account Id',
      selector: 'accountId',
      sortable: false,
      width: '120px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.accountId}
          linkTo={`/accounts/${row.accountId}`}
        />
      ),
    },
    {
      name: 'Account Name',
      selector: 'accountName',
      sortable: false,
      width: '120px',
    },
    {
      name: 'Total Orders',
      selector: 'totalOrders',
      sortable: false,
      width: '120px',
    },
    {
      name: 'Total Orders Value',
      selector: 'totalOrdersValue',
      sortable: false,
      width: '120px',
      format: (row) => <Currency amount={CentsToDollar(row.totalOrdersValue)} default="-" />,
    },
  ], []);
   
  const getTotalOrdersValue = () => {
    let value = 0;
    summary.forEach((order) => {
      value = value + order?.totalOrdersValue;
    });
    return value;
  };
  
  return (
    <div>
      <div className='m-3'>
        <RenderInfo heading="Total orders value" value={CentsToDollar(getTotalOrdersValue()) || 0} type='currency' />
        <RenderInfo heading="Total unique accounts" value={summary?.length} />
      </div>
      <DataTable
        noHeader
        data={summary}
        columns={salesPersonSummaryColumns}
        customStyles={tableStyles}
        highlightOnHover={true}
        keyField="objectId"
        loading={loading}
      />
    </div>
  );
};

export default SalesPersonSummary;